import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/context/AuthContext';

interface Supporter {
    id: number;
    user_name: string;
    user_email: string;
    tier_title: string;
    package_type: string;
}

interface ServerCost {
    id: number;
    year: number;
    progress_percentage: number;
    is_active: boolean;
}

const fetchLatestSupporters = async (): Promise<Supporter[]> => {
    const response = await fetch('/api/supporters/active');
    if (!response.ok) {
        throw new Error('A támogatók betöltése sikertelen.');
    }
    const supporters = await response.json();
    return supporters.slice(0, 3);
};

const fetchServerCosts = async (): Promise<ServerCost[]> => {
    const response = await fetch('/api/server_costs');
    if (!response.ok) {
        throw new Error('A szerver költségek betöltése sikertelen.');
    }
    return response.json();
};

const SupportBanner = () => {
    const { isTranslator } = useAuth();
    const { data: supporters = [] } = useQuery<Supporter[]>({
        queryKey: ['latestSupporters'],
        queryFn: fetchLatestSupporters,
        staleTime: 1000 * 60 * 5,
    });
    const { data: serverCosts = [] } = useQuery<ServerCost[]>({
        queryKey: ['serverCosts'],
        queryFn: fetchServerCosts,
        staleTime: 1000 * 60 * 5,
    });

    // Ellenőrizzük, van-e aktív kampány (progress_percentage < 100 és is_active = true)
    const hasActiveCampaign = serverCosts.some(cost => cost.progress_percentage < 100 && cost.is_active);
    // Ellenőrizzük, van-e bármilyen kampány
    const hasCampaign = serverCosts.length > 0;

    if (isTranslator || !hasCampaign) {
        return null;
    }

    const getStars = (packageType: string) => {
        const count = packageType === '1' ? 1 : packageType === '2' ? 2 : packageType === '3' ? 3 : 0;
        return '⭐'.repeat(count);
    };

    const supporterList = supporters.map(s => `${s.user_name} (${s.user_email}) ${getStars(s.package_type)}`).join('  •  ');

    return (
        <div className="w-full bg-yellow-500 py-2 px-4">
            <div className="flex items-center justify-center gap-3">
                <Heart size={20} className="text-red-600" />
                <span className="text-gray-900 font-semibold text-sm">Gyűjtés a szerver fenntartására:</span>
                <Link to="/ad-free" className="text-gray-900 underline hover:text-gray-800 transition-colors font-bold text-sm">
                    Támogatás »
                </Link>
                <span className="text-gray-900 font-semibold text-sm">Utolsó támogatóink:</span>
                <span className="text-yellow-700 font-bold text-sm">
                    {supporterList}
                </span>
            </div>
        </div>
    );
};

export default SupportBanner;
